/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Status_ConfirmedInputs */

const en_po_status_confirmed = /** @type {(inputs: Po_Status_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmed`)
};

/**
* | output |
* | --- |
* | "Confirmed" |
*
* @param {Po_Status_ConfirmedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_status_confirmed = /** @type {((inputs?: Po_Status_ConfirmedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Status_ConfirmedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_status_confirmed(inputs)
});